import React from 'react';

import cx from 'classnames';
import { Arrow, ToggleLayer } from 'react-laag';
import { useDispatch } from 'react-redux';

import ItemLink from 'components/Layouts/Admin/Dashboard/Navigation/ItemLink';
import Dropdown from 'components/shared/Dropdown';
import MoreButton from 'components/shared/Icon/icons/More';
import { SignOut } from 'components/shared/Icon/phosphorIcons';
import { withNotificationCenter } from 'components/shared/LandingPage/blocks/PageHeader/utils';
import { useTermsModal } from 'components/shared/Layout/shared/UserMenu/functions';
import { MODAL_TYPE } from 'constants/modalTypes';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import i18n from 'i18n';
import { setTermsOfServiceModalOpenAction } from 'store/terms_of_use';
import { isNotDefined } from 'utils/ramda';

import s from './index.module.css';
import { IMobileActionsMenuProps } from './types';

export const MobileActionsMenu = ({ icons, actions, notifications }: IMobileActionsMenuProps) => {
  const dispatch = useDispatch();
  const { modal } = useTermsModal();
  const { isTabletOrMobile } = useMediaBreakpoints();

  return (
    <>
      <ToggleLayer
        fixed
        renderLayer={({ isOpen, layerProps, close, arrowStyle, layerSide }) =>
          isOpen && (
            <div
              ref={layerProps.ref}
              className="layer"
              style={{
                ...layerProps.style,
                zIndex: 9999,
              }}
            >
              <Dropdown className={cx(s.moreActionsMenuWrapper, 'custom-right-header-dropdown')}>
                {icons.map((icon, i) => {
                  if (icon.hint) {
                    if (icon.customElement && isNotDefined(notifications)) return null;

                    const TriggerComponent = (
                      <>
                        {icon.icon}
                        {icon.hint}
                      </>
                    );

                    return (
                      <div
                        key={icon.hint + i}
                        className={cx(s.moreActionsMenuItem)}
                        onClick={() => {
                          !icon.customElement && close();
                          icon.onClick();
                        }}
                      >
                        {icon.customElement && !isNotDefined(notifications)
                          ? withNotificationCenter(TriggerComponent, notifications, isTabletOrMobile)
                          : TriggerComponent}
                      </div>
                    );
                  }

                  return null;
                })}

                {actions.map((action, idx) => (
                  <div key={idx} className={cx(s.moreActionsMenuItem)}>
                    <SignOut size={20} color="#000000" />
                    <ItemLink
                      isButton
                      isDropdown
                      onClick={() => {
                        action.onClick();
                        close();
                      }}
                      className="custom-right-header-user-menu-list-item"
                      linkClassName={cx(s.userMenuListLabel, 'custom-right-header-user-menu-list-label')}
                      noUnderline
                    >
                      {action.label}
                    </ItemLink>
                  </div>
                ))}
                <div>
                  <ItemLink
                    isDropdown={!isTabletOrMobile}
                    isButton
                    noMargin
                    /*@ts-ignore*/
                    onClick={() => dispatch(setTermsOfServiceModalOpenAction(MODAL_TYPE.PRIVACY_POLICY)).then(close)}
                    linkClassName={s.userMenuLink}
                  >
                    {i18n.t('proposal_content.privacy_policy')}
                  </ItemLink>
                  <ItemLink
                    isDropdown={!isTabletOrMobile}
                    isButton
                    noMargin
                    /*@ts-ignore*/
                    onClick={() => dispatch(setTermsOfServiceModalOpenAction(MODAL_TYPE.TERMS_OF_SERVICE)).then(close)}
                    linkClassName={s.userMenuLink}
                  >
                    {i18n.t('proposal_content.terms_conditions')}
                  </ItemLink>
                </div>
              </Dropdown>
              <Arrow
                style={{ ...arrowStyle, height: '1.1rem', zIndex: '21' }}
                layerSide={layerSide}
                borderWidth={1}
                borderColor="rgba(0, 0, 0, 0.04)"
                backgroundColor="#fff"
                angle={40}
                roundness={0.5}
                size={12}
              />
            </div>
          )
        }
        placement={{
          anchor: 'BOTTOM_LEFT',
          autoAdjust: true,
          triggerOffset: 10,
        }}
        closeOnOutsideClick
      >
        {({ triggerRef, toggle }) => {
          return (
            <button
              type="button"
              className={cx(s.userMenu, 'custom-right-header-user-menu')}
              ref={triggerRef}
              onClick={toggle}
            >
              {/*@ts-ignore*/}
              <MoreButton />
            </button>
          );
        }}
      </ToggleLayer>
      {modal}
    </>
  );
};
